import { jsx as n, jsxs as u } from "react/jsx-runtime";
import { Spinner as h, SkeletonText as L, SkeletonTextLine as o } from "@vp/swan";
const y = (a) => {
  const {
    isLoading: r,
    showLoading: i = !0,
    spinnerType: l = "skeleton",
    skeletonLines: d = 2,
    skeletonHeading: f = !1,
    skeletonLineWidths: e = "standard",
    children: g
  } = a, p = (t) => typeof e == "string" ? e : Array.isArray(e) && t < e.length ? typeof e[t] == "string" ? e[t] : e[t].width || "standard" : "standard";
  return i && r ? l === "spinner" ? /* @__PURE__ */ n(h, { style: { width: "100%" }, accessibleText: "Loading", size: "standard" }) : /* @__PURE__ */ u(L, { children: [
    f && /* @__PURE__ */ n(o, { fontSize: "large" }),
    Array(d).fill(0).map((t, s) => /* @__PURE__ */ n(o, { width: p(s) }, `skeleton-loading-${s}`))
  ] }) : !i && r ? null : g;
};
export {
  y as Loader
};
//# sourceMappingURL=contact-channels76.js.map
